export const DELETE_ASSET = 'DELETE_ASSET'
export const DELETE_ASSET_FULFILLED = 'DELETE_ASSET_FULFILLED'
export const DELETE_ASSET_REJECTED = 'DELETE_ASSET_REJECTED'
/**
 * @param {{
 *  assetId: string,
 * }} payload
 * @link: https://promoboxx.postman.co/collections/5683350-e2c61ecf-b84d-4336-b8b0-94d1bd6e53c9?version=latest&workspace=d5e9e9bc-a697-4e1d-8dbc-56461f7af430#3bc6a4d3-946d-435d-8994-fca6ac6fb436
 */
export const deleteAsset = (payload) => ({
  type: DELETE_ASSET,
  payload,
})

export const UPDATE_ASSET = 'UPDATE_ASSET'
export const UPDATE_ASSET_FULFILLED = 'UPDATE_ASSET_FULFILLED'
export const UPDATE_ASSET_REJECTED = 'UPDATE_ASSET_REJECTED'
/**
 * @param {{
 *  assetId: string,
 *  fields: array,
 *  asset: object,
 * }} payload
 * @link: https://promoboxx.postman.co/collections/5683350-e2c61ecf-b84d-4336-b8b0-94d1bd6e53c9?version=latest&workspace=d5e9e9bc-a697-4e1d-8dbc-56461f7af430#34324c53-7644-4baf-85b7-400b105ae04f
 */
export const updateAsset = (payload) => ({
  type: UPDATE_ASSET,
  payload,
})
